// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentChecklistRejectCell-moduleApplicantDocumentChecklistRejectCell__rw6ZS ApplicantDocumentChecklistActionCell-moduleApplicantDocumentChecklistActionCell__DoJnV";
export { _1 as "ApplicantDocumentChecklistRejectCell" }
